<template>
<div>
      <!-- ////////////////////////////////////////
            /////////// D E S K T O P  ////////////
            ///////////////////////////////////////-->

    <nav class="navbar is-fresh  is-transparent is-fixed-top is-hidden-touch" role="navigation" aria-label="main navigation">
        <div class="container">
            <div class="navbar-brand">
                <router-link to="/" class="" active-class="">
                  <img src="../../statics/img/Certicom_logo.png" />
                </router-link>
            </div>
        </div>

        <div id="navbar-menu" class="navbar-menu is-static" :class="{ 'is-active': isMenuActive }">
            <div class="navbar-end">
                <!-- /////////////////////////////
                /////////// H O M E  ////////////
                /////////////////////////////////-->

                    <router-link to="/" exact class="navbar-item">
                        <b-icon icon="home" class="iconHeader"/>
                        <span>Home</span>
                    </router-link>

                <!-- //////////////////////////////////
                /////////// I N T R A N E T ////////////
                ///////////////////////////////////////-->

                    <router-link to="/user/intranet/1010" class="navbar-item">
                        <b-icon icon="file-pdf" class="iconHeader"/>
                        <span>Formatos</span>
                    </router-link>

                <!-- /////////////////////////////
                /////////// C O R R E O ////////////
                /////////////////////////////////-->

                    <a class="navbar-item">
                        <b-icon icon="email" class="iconHeader"/>
                        <span @click="emailintro">Correo</span>
                    </a>
              <!-- /////////////////////////////
                /////////// DRIVE ////////////
                /////////////////////////////////-->
                    <a class="navbar-item">
                      <b-icon icon="google-drive" class="iconHeader"/>
                      <span @click="drivelink">Drive</span>
                    </a>

                    <a class="navbar-item">
                      <b-icon icon="webpack" class="iconHeader"/>
                      <span @click="odoolink">Odoo</span>
                    </a>


                <!-- /////////////////////////////
                /////////// A D M I N  ////////////
                /////////////////////////////////-->

                    <router-link v-if="tienePermiso('admin')" to="/admin" class="navbar-item">
                        <b-icon icon="buffer" class="iconHeader"/>
                        <span>Administración</span>
                    </router-link>

                 <!-- /////////////////////////////////
                 /////////// C U E N T A   ////////////
                ///////////////////////////////////-->

                    <b-dropdown v-if="auth" class="navbar-item">
                        <button class="button is-outlined is-info" slot="trigger">
                          <span>{{auth.user.fullName}}</span>
                          <b-icon icon="menu-down"></b-icon>
                        </button>
                        <router-link to="/setting/account" class="navbar-item">
                          <b-dropdown-item>Mi cuenta</b-dropdown-item>
                        </router-link>

                        <!--<b-dropdown-item>Cambiar Contraseña</b-dropdown-item>-->
                        <b-dropdown-item @click="logout">Cerrar sesión</b-dropdown-item>
                    </b-dropdown>

                    <div v-else class="navbar-item">
                        <a
                        class="button is-outlined"
                        :class="light ? 'is-light' : 'is-twitter'"
                        @click="login">
                        <b-icon icon="account"/>
                        <span>Iniciar sesión</span>
                        </a>
                    </div>
                    <!--<div v-if="verifPhotographyCompute != null" @click="changeImage">
                      <img :src="obtenerUrl(photography)" fluid alt="Responsive image"/>
                    </div>-->
                    <div @click="changeImage">
                      <img src="../../statics/img/avatar.png" fluid alt="Responsive image"/>
                    </div>
            </div>
        </div>
    </nav>

    <!-- ////////////////////////////////////////
            /////////// M O B I L E  ////////////
            ///////////////////////////////////////-->

    <nav class="navbar is-hidden-desktop is-active is-fixed-top">
        <div class="container">
            <div class="navbar-brand">
                <router-link to="/" class="" active-class="">
                    <img src="../../statics/img/Certicom_logo.png"/>
                </router-link>

            <!--<b-field style="margin-left:150px;  margin-top:16px; width:120px">
                    <b-select placeholder="Menu" icon="earth">
                        <option value="1">Option 1</option>
                        <option value="2">Option 2</option>
                    </b-select>
                </b-field>-->
                <div class="navbar-end">
                    <b-dropdown v-if="auth" class="navbar-item">
                        <button class="button is-outlined is-info" slot="trigger">
                          <b-icon icon="home" class="iconHeader"/>
                          <span>Home</span>
                          <b-icon icon="menu-down"></b-icon>
                        </button>
                        <b-dropdown-item>
                            <router-link to="/" exact class="navbar-item">
                                <b-icon icon="home" class="iconHeader"/><div></div>Home
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <router-link to="/user/intranet/1010" class="navbar-item">
                                <b-icon icon="file-pdf" class="iconHeader"/><div></div>Formatos
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item @click="emailintro">
                            <a class="navbar-item">
                                <b-icon icon="email" class="iconHeader"/><div></div>Correo
                            </a>
                        </b-dropdown-item>
                      <b-dropdown-item @click="drivelink">
                        <a class="navbar-item">
                          <b-icon icon="google-drive" class="iconHeader"/><div></div>Drive
                        </a>
                      </b-dropdown-item>
                      <b-dropdown-item @click="odoolink">
                        <a  class="navbar-item">
                          <b-icon icon="webpack" class="iconHeader"/><div></div>Odoo
                        </a>
                      </b-dropdown-item>
                      <b-dropdown-item>
                            <router-link v-if="tienePermiso('admin')" to="/admin" class="navbar-item">
                                <b-icon icon="buffer" class="iconHeader"/><div></div>Administrador
                            </router-link>
                      </b-dropdown-item>

                      <b-dropdown-item @click="logout">Cerrar sesión</b-dropdown-item>
                    </b-dropdown>

                </div>

            </div>


        </div>
    </nav>
</div>
</template>

<script>

    import menu from '../menu'
    const endpointBase = __API__
    import keycloakUtils from '../keycloakUtils'
    import {mapGetters} from 'vuex'
    import ModalForm from './../components/modal/ChangeImage'
    export default {
        props: {
            name:'navbar',
            light: Boolean
        },
        data() {
            return {
                menu,
                /*showNav:false, */
                isPublic: true,
                urlDrive:'https://cloud.certicom.com.pe/index.php/login',
                urlOdoo:'http://10.162.170.221:8069/#id=1133&view_type=form&model=hr.employee&menu_id=373&action=451',
                navIsActive: false,
                isMenuActive:true,
                photography:null,
                urlImagenLogo : '/statics/img/avatar.png',
                endpointBase,
                adoptaList: [
                  '/statics/img/slider/2.jpg',
                  '/statics/img/slider/3.jpg',
                  '/statics/img/slider/1.jpg',
                  '/statics/img/slider/2.jpg',
                  '/statics/img/slider/3.jpg',
                  '/statics/img/slider/1.jpg',
                  '/statics/img/slider/2.jpg',
                  '/statics/img/slider/3.jpg']

            }
        },
        computed:{
          ...mapGetters({'auth':'security/getAuth'}),
          verifPhotographyCompute () {

            this.$http.get('api/photographyByPersonal')
              .then((response) => {
                this.photography = response.data;
              });
            return this.photography
          },
        },
        methods: {
          tienePermiso(rolesPermitidos){
            // for(var i=0;rolesPermitidos.length;i++){

            for(var j=0;j < this.auth.roles.length;j++){
              console.log( this.auth.roles[j])
              if(rolesPermitidos==this.auth.roles[j]){
                return true
              }
            }

            // }
            return false;
          },
          obtenerUrl(idimg){
            if(idimg){
              if(idimg != "" || idimg != "null"){
                return this.endpointBase+'images/imgsPersonal/'+idimg
              }else{
                return this.urlImagenLogo
              }
            }else{
              return this.urlImagenLogo
            }

          },
          changeImage(){
            this.openModalEditUser()
          },
          openModalEditUser(){
            this.$buefy.modal.open({
              parent: this,
              hasModalCard: true,
              width: 600,
              component: ModalForm,
              props: {isEdit: true, editedProfile:Object.assign({}, this.userEdit), idUser: "",imgUser:this.photography}
            })
          },
            closeMenu() {
                this.isMenuActive = false
            },
            toggleMenu(){
                alert('Hola')
                this.navIsActive = !this.navIsActive
            },
            toggleHtmlClip() {
                document
                    .documentElement
                    .classList
                    .toggle('is-clipped-touch', this.isMenuActive)
            },
          logout(){
            this.$keycloak.logoutFn()
          },
          drivelink(){
            window.open(this.urlDrive,'_blank');
          },
          odoolink(){
            window.open(this.urlOdoo,'_blank');
          },
          emailintro(){
            this.$http.get('api/emailinto')
              .then((response) => {
                console.log(response);
                window.open(response.data,'_blank');
              }).catch(function (error) {
              console.log(error);
            });
          },
          login(){
            keycloakUtils.validateSesion(window.keycloak).then()
          }
        },
        created() {
            this.$eventHub.$on('close-menu', this.closeMenu)
            console.log("roles que tengo ", this.auth.roles)
        },
        beforeDestroy() {
            this.$eventHub.$off('close-menu')
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/TheHeader.vue